/**
 * Reconciles the ad hoc `@media (max-width: …)` values scattered across the
 * legacy CSS files (620, 720, 760, 900, 980, 1000, 1024, 1080, 1100, 1240)
 * around the two thresholds `layouts/Shell.tsx` itself documents: the rail
 * overlays below 1080px, and the topbar wraps at 1240px with a long title.
 */
import type { BreakpointsOptions } from '@mui/material/styles';

export const breakpoints: BreakpointsOptions = {
	values: {
		xs: 0,
		sm: 640,
		md: 900,
		lg: 1080,
		xl: 1280,
	},
};
